module.exports = "https://web-assets.ifttt.com/packs/media/partners/play-5c3905d5.svg";